import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchDirecta24Options,
  fetchMifinityOptions,
  selectDropdownOptions,
  selectPaymentIqMerchantId,
  selectPaymentMethod,
  selectUserCountry,
} from '@cashier/cashier-data-access';
import { CountryConverter } from '@cashier/cashier-shared';

interface UseDynamicDropdownProps {
  options: {
    label: string;
    value: string;
  }[];
}

export const useDynamicDropdown = (): UseDynamicDropdownProps => {
  const dispatch = useDispatch();
  const options = useSelector(selectDropdownOptions);
  const merchantId = useSelector(selectPaymentIqMerchantId);
  const paymentMethod = useSelector(selectPaymentMethod);
  const country = useSelector(selectUserCountry);

  const { id: paymentMethodId } = paymentMethod || {};

  useEffect(() => {
    if (!merchantId || !country || !paymentMethodId) {
      return;
    }

    if (paymentMethodId === 'payment-iq-bank-directa24') {
      dispatch(
        fetchDirecta24Options({
          merchantId,
          countryCode: CountryConverter.toIso2(country) || 'US',
        }),
      );
    }

    if (paymentMethodId === 'payment-iq-banklocal-banktransfercan') {
      merchantId && dispatch(fetchMifinityOptions(merchantId));
    }
  }, [dispatch, country, merchantId, paymentMethodId]);

  return {
    options,
  };
};
